export const MONEY_FORMAT = '#,##0.##';
